import React, { useState, useEffect, useCallback } from 'react';
import { toast } from 'react-toastify';
import api from '../services/api';
import BlobConfig from '../components/settings/BlobConfig';
import EmailConfig from '../components/settings/EmailConfig';
import AIKeysConfig from '../components/settings/AIKeysConfig';
import LogoConfig from '../components/settings/LogoConfig';
import InstituteUsers from '../components/settings/InstituteUsers';

const tabs = [
  { id: 'blob', label: 'BLOB CONFIGURATION', icon: '☰' },
  { id: 'email', label: 'EMAIL CONFIGURATION', icon: '✉' },
  { id: 'ai-keys', label: 'AI API KEYS', icon: '🤖' },
  { id: 'logo', label: 'LOGO', icon: '🖼' },
  { id: 'users', label: 'INSTITUTE USERS', icon: '👤' },
];

function Settings() {
  const [activeTab, setActiveTab] = useState('blob');
  const [tenants, setTenants] = useState([]);
  const [selectedTenantId, setSelectedTenantId] = useState('');
  const [loadingTenants, setLoadingTenants] = useState(true);

  const loadTenants = useCallback(async () => {
    try {
      const response = await api.get('/tenants');
      if (response.data.success) {
        setTenants(response.data.data);
        if (response.data.data.length > 0 && !selectedTenantId) {
          setSelectedTenantId(response.data.data[0].TenantID);
        }
      }
    } catch {
      toast.error('Failed to load tenants');
    } finally {
      setLoadingTenants(false);
    }
  }, [selectedTenantId]);

  useEffect(() => {
    loadTenants();
  }, [loadTenants]);

  return (
    <div className="page-card">
      {/* Tenant Selector */}
      <div className="settings-tenant-selector">
        <label>Select Tenant:</label>
        {loadingTenants ? (
          <span style={{ color: '#999' }}>Loading tenants...</span>
        ) : tenants.length === 0 ? (
          <span style={{ color: '#c62828' }}>No tenants found. Please create a tenant first.</span>
        ) : (
          <select
            value={selectedTenantId}
            onChange={(e) => setSelectedTenantId(parseInt(e.target.value))}
          >
            {tenants.map((t) => (
              <option key={t.TenantID} value={t.TenantID}>
                {t.InstituteName} ({t.InstituteCode})
              </option>
            ))}
          </select>
        )}
      </div>

      {/* Tabs */}
      <div className="settings-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`settings-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <span className="settings-tab-icon">{tab.icon}</span>
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      {!selectedTenantId ? (
        <div style={{ textAlign: 'center', padding: 60, color: '#999' }}>
          Please select a tenant to configure settings.
        </div>
      ) : (
        <div className="settings-content">
          {activeTab === 'blob' && <BlobConfig tenantId={selectedTenantId} />}
          {activeTab === 'email' && <EmailConfig tenantId={selectedTenantId} />}
          {activeTab === 'ai-keys' && <AIKeysConfig tenantId={selectedTenantId} />}
          {activeTab === 'logo' && <LogoConfig tenantId={selectedTenantId} />}
          {activeTab === 'users' && <InstituteUsers tenantId={selectedTenantId} />}
        </div>
      )}
    </div>
  );
}

export default Settings;
